import styled from 'styled-components'
import Flex from 'components/Flex'
import Label from 'components/Form/Label'

export const CommonDiv = styled.div`
  margin: 15px 0;
`
export const SalaryFlex = styled(Flex)`
  gap: 25px;
  margin-bottom: 10px;
`
export const CommonFlex = styled(Flex)``

export const LabelWrapper = styled(Label)`
  padding-bottom: 8px;
`
export const LabelWrapperText = styled.div`
  font-style: normal;
  font-weight: 500;
  font-size: 15px;
  line-height: 18px;
  color: rgb(77, 86, 110);
  margin-bottom: 13px !important;


`
